<ac-button (acClick)="acClick.emit(_isViewMode)"
           [ngDisabled]="ngDisabled===null?true:ngDisabled"
           class="ac-toolbar-action">
    <i *ngIf="actions[actionType].icon" class="fa {{actions[actionType].icon}} action-icon"></i>
    <span *ngIf="actions[actionType].text && actions[actionType].text !== ''">{{actions[actionType].text}}</span>
</ac-button>
